import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * Gynecologist icon
 *
 * @category Medical
 */
const Gynecologist = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M28.405 8.273c-.642-.772-1.956-.742-2.818-.411-1.203.46-2.307 1.504-3.68 1.313-.793-.11-1.434-.692-2.106-1.123-2.076-1.344-4.914-1.394-7.04-.13-.762.451-1.474 1.083-2.357 1.213-1.976.301-5.485-3.32-6.94-.611-.29.551-.27 1.253.05 1.795.392.641 1.144.972 1.886 1.123.29.06.622.12.802.36.25.332.06.793-.07 1.184-.17.481-.26 1.003-.14 1.494s.45.953.942 1.114c.752.25 1.605-.351 1.825-1.114.221-.762-.06-1.594-.501-2.256a4.6 4.6 0 0 0-2.377-1.765c-.39-.12-.822-.2-1.143-.461-.32-.261-.491-.773-.22-1.083.21-.241.581-.251.902-.231 1.233.1 2.437.461 3.51 1.063.371.21.742.461.973.822.571.903.07 2.076.08 3.14.02 1.303.812 2.446 1.274 3.66.541 1.403.651 2.968 1.323 4.312.562 1.143 1.524 2.116 1.755 3.37.09.5.08 1.062.411 1.453.311.371.843.472 1.324.431.391-.03.792-.13 1.073-.41.512-.502.421-1.334.622-2.026.27-.953 1.103-1.625 1.614-2.477.642-1.063.763-2.357 1.194-3.53.451-1.254 1.263-2.387 1.514-3.69.391-2.077-.762-3.832 1.524-5.085.522-.28 4.272-1.986 4.062-.321-.04.31-.28.562-.562.712-.28.15-.591.22-.892.31a4.76 4.76 0 0 0-2.327 1.646c-.491.641-.812 1.464-.632 2.256s1.003 1.444 1.785 1.233c.843-.23 1.194-1.303.963-2.146-.15-.521-.451-1.113-.14-1.564.19-.27.531-.371.852-.472.782-.24 1.615-.621 1.946-1.373.25-.552.17-1.234-.2-1.705 0-.01-.021-.02-.031-.04zM7.907 14.49c-.552 1.063-1.454-.25-1.053-1.103.552-1.263 1.424.21 1.113.943l-.06.17zm11.863 2.768c-.45.652-.42 1.524-.561 2.196a5.9 5.9 0 0 1-1.113 2.528c-.522.722-1.304 1.684-1.464 2.547-.08.471-.14 1.334-.763 1.323-.541-.14-.48-.872-.611-1.323-.16-.833-.702-1.675-1.143-2.217-.492-.621-.973-1.514-1.154-2.416-.18-.983-.24-2.447-.752-2.999-2.687-3.71-.952-9.326 4.202-8.985 1.986.06 4.122 1.103 4.553 3.41.381 1.915.2 4.372-1.123 5.816l-.08.11zm5.366-2.738c-.552 1.074-1.424-.26-1.033-1.103.561-1.283 1.384.22 1.093.943l-.06.17z"
        />
        <path
          fill="currentColor"
          d="M18.828 14.7c-.401.452-.421 1.255-.692 1.866-.592 1.354-1.324 2.497-1.665 3.992-.11.27-.23.822-.521.772-.341-.291-.401-.963-.562-1.404-.32-1.525-1.444-2.688-1.785-4.192-.1-.28-.27-1.083-.662-.772-.441.702.04 1.795.401 2.497 1.033 1.584 1.434 3.47 2.006 5.325.582 1.474 1.284.38 1.524-.612.472-1.534.803-2.898 1.545-4.172.42-.842 1.333-2.627.491-3.34l-.07.03z"
        />
      </svg>
    );
  }
);

Gynecologist.displayName = 'Gynecologist';

export { Gynecologist };
